import { NO_VALUE_DISPLAY } from "@/appConfig";

export function optionalDisplayValue(val: any, display: any) {
  if (val === undefined || val === null || val === "") return NO_VALUE_DISPLAY;
  return display;
}
